import { BodyText } from '@calendly/ui/components/typography'

import { FieldsContainer } from '../../elements'

export const Base = ({
  header,
  children,
}) => (
  <FieldsContainer>
    {header && <BodyText size="medium" weight="bold">{header}</BodyText>}
    {children}
  </FieldsContainer>
)
